import { orderBookFComponents } from "./orders/navigationComponents";
import { portfolioFReportComponents } from "./portfolio/navigationComponents";
import { tradesFComponents } from "./trades/navigationComponents";
import { tradesSumFComponents } from "./tradessum/navigationComponents";
import { mainBoardComponents } from "./mainBoard/navigationComponents";

export const foreignComponents = [...orderBookFComponents, ...portfolioFReportComponents, ...tradesFComponents, ...tradesSumFComponents,...mainBoardComponents];
